import { useIntl } from 'react-intl';
import { ActionExecutionResult } from '@rossum/api-client/rulesExecutionLogs';
import { Chip, Typography } from '@rossum/ui/material';
import { GridColDef } from '@rossum/ui/x-data-grid-pro';

export type ActionRow = ActionExecutionResult & { id: string };

export const useActionColumns = (): GridColDef<ActionRow>[] => {
  const intl = useIntl();

  return [
    {
      field: 'actionType',
      headerName: intl.formatMessage({
        id: 'features.rulesExecutionLogs.actions.columns.actionType',
      }),
      flex: 2,
      minWidth: 200,
    },
    {
      field: 'success',
      headerName: intl.formatMessage({
        id: 'features.rulesExecutionLogs.actions.columns.status',
      }),
      flex: 1,
      minWidth: 120,
      renderCell: ({ value }) => (
        <Chip
          label={
            value
              ? intl.formatMessage({
                  id: 'features.rulesExecutionLogs.status.success',
                })
              : intl.formatMessage({
                  id: 'features.rulesExecutionLogs.status.failure',
                })
          }
          size="small"
          color={value ? 'success' : 'error'}
        />
      ),
    },
    {
      field: 'error',
      headerName: intl.formatMessage({
        id: 'features.rulesExecutionLogs.actions.columns.error',
      }),
      flex: 2,
      minWidth: 200,
      renderCell: ({ value }) => (
        <Typography
          variant="body2"
          color={value ? 'error' : 'text.secondary'}
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {value || '-'}
        </Typography>
      ),
    },
  ];
};
